import React, { useEffect, useRef } from "react";
import "../../styles/animatica.css";
import img from "../../assets/images/webp/colaj.jpg";
import { tiltHandlers } from "./useTilt";

const CONTENT_TYPES = [
  {
    title: "Educational & Infotainment Videos",
    text: "Multilingual, market-ready content for regional and global audiences.",
  },
  {
    title: "Period Dramas & Religious Stories",
    text: "Bring legends like Veer Teja Ji and mythological tales like Shiv Puran to life.",
  },
  {
    title: "Localized Kids' Heroes",
    text: "Develop cultural icons in regional languages inspired by hits like Chhota Bheem.",
  },
  {
    title: "High RPM Content",
    text: "Target lucrative international markets, including the USA and Western Europe.",
  },
  {
    title: "Development of Gaming & Comic IPs",
    text: "Developing immersive gaming experiences and original comic IPs, we are at the forefront of entertainment innovation.",
  },
];

const DynamicContent = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className="an-section py-5"
    >
      <div className="an-glow an-glow-right" />
      <div className="container position-relative">
        <div className="row justify-content-between align-items-center">
          <div className="col-md-5 an-reveal an-reveal-d1">
            <div className="an-img-wrap an-tilt" {...tiltHandlers}>
              <div className="an-img-inner">
                <img loading="lazy" decoding="async" className="w-100" src={img} alt="img" />
              </div>
            </div>
          </div>
          <div className="col-md-6 mt-4 mt-md-0 position-relative">
            <span className="an-reveal an-reveal-d2 an-eyebrow">
              What We Produce
            </span>
            <h3
              className="an-reveal an-reveal-d3 fs_35 fw-bold ff_s"
              style={{ color: "#f8fafc" }}
            >
              ICASA Content Studio
            </h3>
            <p
              className="an-reveal an-reveal-d4 fs_16 ff_n text_justify mb-0 mt-3"
              style={{ color: "rgba(248, 250, 252, 0.68)" }}
            >
              With a focus on regional relevance and global appeal, each HKI
              Animatica Center of Excellence (CoE) will produce 500 minutes of
              premium content annually, spanning:
            </p>
            <ul className="an-reveal an-reveal-d5 an-num-list mt-4">
              {CONTENT_TYPES.map((item, index) => (
                <li key={item.title} className="an-num-item">
                  <span className="an-num-badge">{index + 1}</span>
                  <p className="fs_16 ff_n mb-0" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
                    <strong style={{ color: "#ef4444" }}>{item.title}:&nbsp;</strong>{" "}
                    {item.text}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicContent;
